import { v4 as uuid } from 'uuid';
import {
  NavItem,
} from './styled';

export const Navigation = ({routes}) => {

  return routes.map((item)=> (
    <NavItem key={uuid()} to={item.route}>{item.routeName}</NavItem>
  ));;
};
